module.exports = __webpack_public_path__ + "static/media/cockroach(12).d0cd920b.PNG";